stage.verExternal = '2.5.3';
stage.languageList = 'zh,en,pt,es,nl,pl';// 支持的国际化种类
stage.loc.customer = 'CSICloud';// oem客户的名称
stage.loc.platformName = 'CSI CloudPro';
stage.loc.platformCode = 'CSI_CLOUDPRO';// 后端定义的平台code
$.extend(true, stage.loc, {
	// baseRouter:"/pro/",//对子路径的场景配置
	statistic: {// 网站统计代码地址
		baidu: 'https://hm.baidu.com/hm.js?c326fd3753cda4380e25b0d74b36592e'
	},
	key: {
		amap: 'ae2ea6f07b931080f439f0ba103e7081',
		amap_host: location.origin + '/_AMapService', // 优先使用后台转发
		google: 'AIzaSyDU94RvHoRJUPW4PZDQXlFbmcGLWGch4Oo'
	},
	logo: {// logo地址
		login: {public: `${stage.loc.baseRouter}static/oem/${stage.loc.customer}/image/logo.svg`},
		system: {public: `${stage.loc.baseRouter}static/oem/${stage.loc.customer}/image/logo.svg`}
	},
	customerDisplay: {// 用来展示的定制化名称
		public: 'CSI Cloud'
	}
});
// stage.loc.logo=[`static/oem/${stage.loc.customer}/image/logo.svg`,`${stage.loc.baseRouter}static/oem/${stage.loc.customer}/image/logo.svg`];
$.extend(true, stage.setting.loc, {
	privacyStatementUrl: {// 服务协议链接
		zh: `${stage.loc.baseRouter}static/oem/${stage.loc.customer}/privacy/privacy_zh.html`,
		en: `${stage.loc.baseRouter}static/oem/${stage.loc.customer}/privacy/privacy_en.html`,
		pt: `${stage.loc.baseRouter}static/oem/${stage.loc.customer}/privacy/privacy_pt.html`,
		es: `${stage.loc.baseRouter}static/oem/${stage.loc.customer}/privacy/privacy_es.html`,
		nl: `${stage.loc.baseRouter}static/oem/${stage.loc.customer}/privacy/privacy_en.html`,
		pl: `${stage.loc.baseRouter}static/oem/${stage.loc.customer}/privacy/privacy_en.html`
	},
	privacyPolicyUrl: {// 隐私协议声明的跳转链接
		zh: `https://protocol.solarmanpv.com/CSI/privacy-policy_pro_zh.html`,
		en: `https://protocol.solarmanpv.com/CSI/privacy-policy_pro_en.html`,
		pt: `https://protocol.solarmanpv.com/CSI/privacy-policy_pro_en.html`,
		es: `https://protocol.solarmanpv.com/CSI/privacy-policy_pro_en.html`,
		nl: `https://protocol.solarmanpv.com/CSI/privacy-policy_pro_en.html`,
		pl: `https://protocol.solarmanpv.com/CSI/privacy-policy_pro_en.html`

	},
	'2in1': {
		cover: {
			b: `${stage.loc.baseRouter}static/oem/${stage.loc.customer}/image/2in1/b.jpg`,
			c: `${stage.loc.baseRouter}static/oem/${stage.loc.customer}/image/2in1/c.jpg`
		},
		file: {
			b: {
				web: {
					zh: [`${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/b/CSI Cloud Pro Web-zh.pdf`, `static/oem/${stage.loc.customer}/file/2in1/b/CSI Cloud Pro Web simple-zh.pdf`],
					en: [`${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/b/CSI Cloud Pro Web-en.pdf`, `static/oem/${stage.loc.customer}/file/2in1/b/CSI Cloud Pro Web simple-en.pdf`],
					pt: [`${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/b/CSI Cloud Pro Web-en.pdf`, `static/oem/${stage.loc.customer}/file/2in1/b/CSI Cloud Pro Web APP simple-pt.pdf`],
					es: [`${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/b/CSI Cloud Pro Web-en.pdf`, `static/oem/${stage.loc.customer}/file/2in1/b/CSI Cloud Pro Web simple-en.pdf`],
					nl: [`${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/b/CSI Cloud Pro Web-en.pdf`, `static/oem/${stage.loc.customer}/file/2in1/b/CSI Cloud Pro Web simple-en.pdf`],
					pl: [`${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/b/CSI Cloud Pro Web-en.pdf`, `static/oem/${stage.loc.customer}/file/2in1/b/CSI Cloud Pro Web simple-en.pdf`]
				},
				app: {
					zh: [`${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/b/CSI Cloud Pro APP-zh.pdf`, `static/oem/${stage.loc.customer}/file/2in1/b/CSI Cloud Pro APP simple-zh.pdf`],
					en: [`${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/b/CSI Cloud Pro APP-en.pdf`, `static/oem/${stage.loc.customer}/file/2in1/b/CSI Cloud Pro APP simple-en.pdf`],
					pt: [`${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/b/CSI Cloud Pro APP-en.pdf`, `static/oem/${stage.loc.customer}/file/2in1/b/CSI Cloud Pro Web APP simple-pt.pdf`],
					es: [`${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/b/CSI Cloud Pro APP-en.pdf`, `static/oem/${stage.loc.customer}/file/2in1/b/CSI Cloud Pro APP simple-en.pdf`],
					nl: [`${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/b/CSI Cloud Pro APP-en.pdf`, `static/oem/${stage.loc.customer}/file/2in1/b/CSI Cloud Pro APP simple-en.pdf`],
					pl: [`${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/b/CSI Cloud Pro APP-en.pdf`, `static/oem/${stage.loc.customer}/file/2in1/b/CSI Cloud Pro APP simple-en.pdf`]
				},
				qa: {
					zh: `${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/b/CSI CloudPro Q&A（中文）.docx`,
					en: `${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/b/CSI CloudPro Q&A（En).docx`,
					pt: `${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/b/CSI CloudPro Q&A(PT).docx`,
					es: `${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/b/CSI CloudPro Q&A(ES).docx`,
					nl: `${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/b/CSI CloudPro Q&A（En).docx`,
					pl: `${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/b/CSI CloudPro Q&A（En).docx`
				}
			},
			c: {
				web: {
					zh: [`${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/c/CSI Cloud - Web-zh.pdf`],
					en: [`${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/c/CSI Cloud - Web-en.pdf`],
					pt: [`${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/c/CSI Cloud - Web-en.pdf`],
					es: [`${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/c/CSI Cloud - Web-en.pdf`],
					nl: [`${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/c/CSI Cloud - Web-en.pdf`],
					pl: [`${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/c/CSI Cloud - Web-en.pdf`]
				},
				app: {
					zh: [`${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/c/CSI Cloud - App-zh.pdf`],
					en: [`${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/c/CSI Cloud - App-en.pdf`],
					pt: [`${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/c/CSI Cloud - App-en.pdf`],
					es: [`${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/c/CSI Cloud - App-en.pdf`],
					nl: [`${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/c/CSI Cloud - App-en.pdf`],
					pl: [`${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/c/CSI Cloud - App-en.pdf`]
				},
				qa: {
					zh: `${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/c/CSI Cloud Q&A（中文）.docx`,
					en: `${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/c/CSI Cloud Q&A（EN）.docx`,
					pt: `${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/c/CSI Cloud Q&A(PT).docx`,
					es: `${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/c/CSI Cloud Q&A(ES).docx`,
					nl: `${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/c/CSI Cloud Q&A（EN）.docx`,
					pl: `${stage.loc.baseRouter}static/oem/${stage.loc.customer}/file/2in1/c/CSI Cloud Q&A（EN）.docx`
				}
			}
		},
		notice: {
			cookie: `platformSelect_2`,
			// <span class="b fsI"></span>
			// <span class="cMain"></span>
			zh: `
				<div class="lh15">
					<h2 class="taC">Monitoring System Upgrade Notice</h2>
					<p>Dear customer,</p>
					<p>We are writing to inform you that we have upgraded our new Monitoring System, to provide better functions and service experiences.</p>
					<p>After upgrading, please be aware of the following changes of the new monitoring system</p>
					<p>
						1.	The GUI of the system is cleaner and user-friendly than previous version.<br>
						2.	Please update your mobile APPs in terms of Android or IOS version of “<span class="b fsI">CSI Cloud</span>” for end-users to V2.0.0 from V1.0.1 (IOS) or V1.0.8 (Android).<br>
						3.	The old version of Android or IOS version of “<span class="b fsI">CSI Cloud</span>” cannot view the new data before updating.<br>
						4.	The professional APPs for our distributers/installers will be online with Google Play or Apple Store in terms of Android or IOS version named “<span class="b fsI">CSI CloudPro</span>” with Version V2.0.0
					</p>
					<p>We recommend you use <span class="b fsI">Google Chrome or “FireFox”</span> to visit the Web of Monitoring system for better display performance.<br>
						<span class="pl1x">•	<span class="b fsI">Internet Explorer</span> Web Browser is not being supported at this time</span>
					</p>
					<p>Please feel free to contact us for any question regarding to the new monitoring system. </p>
					<p>Sincerely,</p>
					<p>
						Canadian Solar Brasil<br>
						Product Team LATAM<br>
						CSI_Monitoring_Help@canadiansolar.com
					</p>
				</div>
			`,
			en: `
				<div class="lh15">
					<h2 class="taC">Monitoring System Upgrade Notice</h2>
					<p>Dear customer,</p>
					<p>We are writing to inform you that we have upgraded our new Monitoring System, to provide better functions and service experiences.</p>
					<p>After upgrading, please be aware of the following changes of the new monitoring system</p>
					<p>
						1.	The GUI of the system is cleaner and user-friendly than previous version.<br>
						2.	Please update your mobile APPs in terms of Android or IOS version of “<span class="b fsI">CSI Cloud</span>” for end-users to V2.0.0 from V1.0.1 (IOS) or V1.0.8 (Android).<br>
						3.	The old version of Android or IOS version of “<span class="b fsI">CSI Cloud</span>” cannot view the new data before updating.<br>
						4.	The professional APPs for our distributers/installers will be online with Google Play or Apple Store in terms of Android or IOS version named “<span class="b fsI">CSI CloudPro</span>” with Version V2.0.0
					</p>
					<p>We recommend you use <span class="b fsI">Google Chrome or “FireFox”</span> to visit the Web of Monitoring system for better display performance.<br>
						<span class="pl1x">•	<span class="b fsI">Internet Explorer</span> Web Browser is not being supported at this time</span>
					</p>
					<p>Please feel free to contact us for any question regarding to the new monitoring system. </p>
					<p>Sincerely,</p>
					<p>
						Canadian Solar Brasil<br>
						Product Team LATAM<br>
						CSI_Monitoring_Help@canadiansolar.com
					</p>
				</div>
			`, // <span class="b fsI"></span>
			pt: `
				<div class="lh15">
					<h2 class="taC">Aviso de atualização do sistema de monitoramento</h2>
					<p>Prezado cliente,</p>
					<p>Estamos escrevendo para informá-lo de que atualizamos nosso novo Sistema de Monitoramento para fornecer melhores funções e experiências de serviço.</p>
					<p>Após a atualização, esteja ciente das seguintes alterações do novo sistema de monitoramento:</p>
					<p>
						1.	A interface do sistema é mais limpa e fácil de usar do que a versão anterior.<br>
						2.	Atualize seus aplicativos para dispositivos móveis Android ou IOS do “<span class="b fsI">CSI Cloud</span>” para usuários finais da V2.0.0 da V1.0.1 (IOS) ou V1.0.8 (Android).<br>
						3.	A versão antiga do Android ou IOS do “<span class="b fsI">CSI Cloud</span>”, não poderá visualizar os novos dados antes da atualização.<br>
						4.	Os aplicativos profissionais para nossos distribuidores / instaladores estarão on-line no Google Play para Android ou na Apple Store para IOS denominada “<span class="b fsI">CSI CloudPro</span>” com a versão V2.0.0.
					</p>
					<p>
						Recomendamos que você use o <span class="b fsI">Google Chrome ou "FireFox"</span> para visitar o sistema de monitoramento obtendo melhor desempenho de exibição.<br>
						<span class="pl1x">•	O <span class="b fsI">Internet Explorer</span> Web Browser não está compatível no momento.</span>
					</p>
					<p>Em caso de dúvidas, estamos à disposição.</p>
					<p>Atenciosamente,</p>
					<p>
						Canadian Solar Brasil<br>
						Equipe de Produto LATAM<br>
						CSI_Monitoring_Help@canadiansolar.com
					</p>
				</div>
			`, // <span class="b fsI"></span>
			es: `
				<div class="lh15">
					<h2 class="taC">Aviso de actualización de la plataforma de monitoreo</h2>
					<p>Estimado cliente,</p>
					<p>Le escribimos para informarle que hemos actualizado nuestro nuevo Sistema de Monitoreo, para proporcionar mejores funciones y experiencias de servicio.</p>
					<p>Después de la actualización se podrán percibir los siguientes cambios en la nueva plataforma:</p>
					<p>
						1.	La interfaz de la plataforma es más limpia y amigable que la versión anterior.<br>
						2.	Actualice el aplicativo “<span class="b fsI">CSI Cloud</span>” para cliente final de la versión v1.0.1 (iOS) o v1.0.8 (Android), a la versión v2.0.0.<br>
						3.	El antiguo aplicativo “<span class="b fsI">CSI Cloud</span>” no será capaz de visualizar los nuevo datos después de la actualización de la plataforma.<br>
						4.	El aplicativo para profesionales y distribuidores estará disponible en Google Play o la Apple Store para Android o iOS con el nombre “<span class="b fsI">CSI CloudPro</span>” con la versión v2.0.0.
					</p>
					<p>Sugerimos que se utilice el navegador <span class="b fsI">Google Chrome</span> o <span class="b fsI">FireFox</span>  para mejorar la utilización de la plataforma de monitoreo en la web.<br>
						<span class="pl1x">•	El navegador <span class="b fsI">Internet Explorer</span> no es compatible en estos momentos.</span>
					</p>
					<p>Estamos a su disposición en el caso de que tenga alguna duda relacionada a la nueva plataforma de monitoreo.</p>
					<p>Sinceramente,</p>
					<p>
						Canadian Solar Brasil<br>
						Equipo de Producto LATAM<br>
						CSI_Monitoring_Help@canadiansolar.com
					</p>
				</div>
			`,
			nl: `
				<div class="lh15">
					<h2 class="taC">Monitoring System Upgrade Notice</h2>
					<p>Dear customer,</p>
					<p>We are writing to inform you that we have upgraded our new Monitoring System, to provide better functions and service experiences.</p>
					<p>After upgrading, please be aware of the following changes of the new monitoring system</p>
					<p>
						1.	The GUI of the system is cleaner and user-friendly than previous version.<br>
						2.	Please update your mobile APPs in terms of Android or IOS version of “<span class="b fsI">CSI Cloud</span>” for end-users to V2.0.0 from V1.0.1 (IOS) or V1.0.8 (Android).<br>
						3.	The old version of Android or IOS version of “<span class="b fsI">CSI Cloud</span>” cannot view the new data before updating.<br>
						4.	The professional APPs for our distributers/installers will be online with Google Play or Apple Store in terms of Android or IOS version named “<span class="b fsI">CSI CloudPro</span>” with Version V2.0.0
					</p>
					<p>We recommend you use <span class="b fsI">Google Chrome or “FireFox”</span> to visit the Web of Monitoring system for better display performance.<br>
						<span class="pl1x">•	<span class="b fsI">Internet Explorer</span> Web Browser is not being supported at this time</span>
					</p>
					<p>Please feel free to contact us for any question regarding to the new monitoring system. </p>
					<p>Sincerely,</p>
					<p>
						Canadian Solar Brasil<br>
						Product Team LATAM<br>
						CSI_Monitoring_Help@canadiansolar.com
					</p>
				</div>
			`,
			pl: `
				<div class="lh15">
					<h2 class="taC">Monitoring System Upgrade Notice</h2>
					<p>Dear customer,</p>
					<p>We are writing to inform you that we have upgraded our new Monitoring System, to provide better functions and service experiences.</p>
					<p>After upgrading, please be aware of the following changes of the new monitoring system</p>
					<p>
						1.	The GUI of the system is cleaner and user-friendly than previous version.<br>
						2.	Please update your mobile APPs in terms of Android or IOS version of “<span class="b fsI">CSI Cloud</span>” for end-users to V2.0.0 from V1.0.1 (IOS) or V1.0.8 (Android).<br>
						3.	The old version of Android or IOS version of “<span class="b fsI">CSI Cloud</span>” cannot view the new data before updating.<br>
						4.	The professional APPs for our distributers/installers will be online with Google Play or Apple Store in terms of Android or IOS version named “<span class="b fsI">CSI CloudPro</span>” with Version V2.0.0
					</p>
					<p>We recommend you use <span class="b fsI">Google Chrome or “FireFox”</span> to visit the Web of Monitoring system for better display performance.<br>
						<span class="pl1x">•	<span class="b fsI">Internet Explorer</span> Web Browser is not being supported at this time</span>
					</p>
					<p>Please feel free to contact us for any question regarding to the new monitoring system. </p>
					<p>Sincerely,</p>
					<p>
						Canadian Solar Brasil<br>
						Product Team LATAM<br>
						CSI_Monitoring_Help@canadiansolar.com
					</p>
				</div>
			`
			// es:`
			// 	<div class="lh15">
			// 		<h2 class="taC"></h2>
			// 		<p></p>
			// 		<p></p>
			// 		<p></p>
			// 		<p><br>
			// 		</p>
			// 		<p><br>
			// 			<span class="pl1x"><span class="b fsI"></span></span>
			// 		</p>
			// 		<p></p>
			// 		<p></p>
			// 		<p><br>
			// 		</p>
			// 	</div>
			// `
		}
	},
	appQR: {// app下载二维码地址
		b: {
			src: `/static/oem/${stage.loc.customer}/image/qr.png`, // ${stage.loc.baseRouter}
			name: {
				zh: 'CSI CloudPro',
				en: 'CSI CloudPro',
				pt: 'CSI CloudPro',
				es: 'CSI CloudPro',
				nl: 'CSI CloudPro',
				pl: 'CSI CloudPro'
			}
		},
		c: {
			src: ``,
			name: {
				zh: '',
				en: '',
				pt: '',
				es: '',
				nl: '',
				pl: ''
			}
		}

	},
	replaceUrl: [// 替换url
		{
			from: ['/oem/canadianSolar/CSI_CloudPro.html'],
			// to:`/static/oem/${stage.loc.customer}/downloadApp/CSI_CloudPro.html`
			to: `//webmonitoring.csisolar.com/oem/canadianSolar/CSI_CloudPro.html`
		},
		{
			from: ['/oem/canadianSolar/CSI_Cloud.html'],
			// to:`/static/oem/${stage.loc.customer}/downloadApp/CSI_Cloud.html`
			to: `//webmonitoring.csisolar.com/oem/canadianSolar/CSI_Cloud.html`
		}
	],
	shieldBlackList: {
		plantLayout: true
	},
	shieldWhiteList: {
    	Announcement: true,
		app: {
			IVCurveItemStruct: true,
			deviceMap: true
		},
		mapMode: {
			plant: true
		},
		orderManagement: true
	}
});
// stage.type.c="http://"+location.hostname+":81";
stage.type.c = '//' + location.hostname + '/home/login';
$.extend(true, stage.color, {// 配置js的颜色系统
	main: '#ca0b0f',
	blueLight: '#3badf6',
	blueDark: '#5383ed',
	redLight: '#ff595f',
	// red: "#ff595f",
	redDark: '#ff262d',
	yellowLight: '#ffb93d',
	yellowDark: '#fb9678',
	// green: "#21ad5c",
	greenLight: '#0ccfc5',
	greenDark: '#30c790',
	// orange: "#fc7304",
	primary: '#ca0b0f',
	danger: '#fdc300',
	warning: '#ca0b0f',
	success: '#0ccfc5',
	list: ['#cf1a20', '#ffc310', '#879f3e', '#6c6e72', '#f36420', '#9b9d9f', '#ff585e', '#5283ed']
});
// stage.languageId=2;//设置默认语言



// WEBPACK FOOTER //
// ./src/oem/js/CSICloud.js